webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2x06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      posts: [],
      transition: 'preview-appear'
    };
  },


  computed: {
    reading: function reading() {
      return this.filters.post;
    },
    scrollDelay: function scrollDelay() {
      return this.$device.phone ? 0 : 560;
    },
    figureClass: function figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading };
    },
    feed: function feed() {
      var _this = this;

      var filterBy = {
        post: function post(filter, _ref) {
          var id = _ref.id;
          return filter === id;
        },
        author: function author(filter, _ref2) {
          var _author = _ref2.author;
          return filter === _this.kebabify(_author);
        }
      };

      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) return this.posts;

      return this.posts.filter(function (post) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.filters).every(function (filter) {
          return filterBy[filter](_this.filters[filter], post);
        });
      });
    }
  },

  methods: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* scrollTo */],
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* prettyDate */],
    getBgImg: function getBgImg(src) {
      return { backgroundImage: 'url(' + src + ')' };
    },
    stackPosts: function stackPosts(posts) {
      var _this2 = this;

      var interval = void 0;
      var stack = function stack() {
        _this2.posts.push(posts.shift());

        if (!posts.length) {
          _this2.transition = 'preview';
          clearInterval(interval);
        }
      };

      interval = setInterval(stack, 125);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$getResource('feed').then(function (posts) {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.filters).length) {
        _this3.stackPosts(posts);
      } else {
        _this3.posts = posts;
        _this3.transition = 'preview';
      }
    });
  }
});

/***/ }),

/***/ "6Lyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'blog-footer' });

/***/ }),

/***/ "7GPK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/it.a0f2715.svg";

/***/ }),

/***/ "8wFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9k9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("eJ85");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Blog", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("bksL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogFeed", function() { return __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("rcwA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogPost", function() { return __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a"]; });




/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("xdpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("InHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlogFooter__ = __webpack_require__("kYEd");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog',
  components: { BlogNav: __WEBPACK_IMPORTED_MODULE_0__BlogNav__["a" /* default */], BlogFeed: __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a" /* default */], BlogPost: __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a" /* default */], BlogFooter: __WEBPACK_IMPORTED_MODULE_3__BlogFooter__["a" /* default */] },
  resource: 'Blog',
  props: {
    post: String,
    author: String
  },

  data: function data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: ''
      }
    };
  },


  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels };
    },
    filters: function filters() {
      var filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    '$route.name': function $routeName(to, from) {
      if (to !== from) this.navs++;
    }
  },

  mounted: function mounted() {
    this.$getResource('blog').then(function (x) {
      // use pace hook to know when rendering is ready
    });
  }
});

/***/ }),

/***/ "Ctlb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7C/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VueDisqus from "vue-disqus/VueDisqus";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blog-post",
  resource: "BlogPost",
  // components: { VueDisqus },
  props: { post: String },

  data: function data() {
    var _ref;

    return _ref = {
      manual: "",
      title: "",
      author: "",
      content: ""
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "manual", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "published", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "description", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sold", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "buy", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "commentsReady", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "ready", false), _ref;
  },


  computed: {
    allReady: function allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    post: function post(to, from) {
      var _this = this;

      if (to === from || !this.post) return;

      this.commentsReady = false;
      this.$getResource("post", to).then(this.showComments).then(function () {
        _this.ready = true;
      });
    }
  },

  methods: {
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* prettyDate */],
    showComments: function showComments() {
      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      // if (
      //   window.__PRERENDER_INJECTED &&
      //   window.__PRERENDER_INJECTED.prerendered
      // ) {
      //   return;
      // }
      // setTimeout(() => {
      //   this.commentsReady = true;
      // }, 1000);
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (!this.post) {
      this.ready = true;
      return;
    }

    this.$getResource("post", this.post).then(this.showComments).then(function () {
      _this2.ready = true;
    });
  }
});

/***/ }),

/***/ "ILtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"blog__feed",attrs:{"tag":"ul","name":_vm.transition}},_vm._l((_vm.feed),function(post){return _c('li',{key:post.id,staticClass:"preview"},[_c('figure',{staticClass:"preview__figure",class:_vm.figureClass,style:(_vm.getBgImg(post.image))},[_c('transition',{attrs:{"name":"v--fade"}},[(!_vm.reading || _vm.$device.phone)?_c('figcaption',{staticClass:"preview__details"},[_c('router-link',{staticClass:"preview__title",attrs:{"to":("/read/" + (post.id))},nativeOn:{"click":function($event){return _vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v(_vm._s(post.title))]),_vm._v(" "),_c('div',{staticClass:"preview__meta"},[_c('router-link',{staticClass:"preview__author",attrs:{"to":("/by/" + (_vm.kebabify(post.author)))},nativeOn:{"click":function($event){return _vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v(_vm._s(post.author))])],1),_vm._v(" "),_c('div',{staticClass:"fr"},[(!post.sold)?_c('time',[_c('a',{staticClass:"buy",attrs:{"href":'https://ebay.com/itm/' + post.buy}},[_vm._v("BUY IT NOW")])]):_c('time',{staticClass:"muted"},[_vm._v("SOLD OUT")])])],1):_vm._e()])],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "InHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__("E7C/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e91708_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__("num+");
function injectStyle (ssrContext) {
  __webpack_require__("Ctlb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44e91708"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e91708_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd38006e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("8wFD");
function injectStyle (ssrContext) {
  __webpack_require__("hi3H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd38006e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MdQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matchMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


var matchMediaFallback = function matchMediaFallback() {
  var listeners = [];
  var idle = true;

  var device = function () {
    var node = document.createElement('div');
    var style = document.createElement('style');

    node.id = 'match-media-node';
    style.innerHTML = '#match-media-node {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      bottom: 100%;\n      overflow: scroll;\n    }';

    document.head.appendChild(style);
    document.body.insertBefore(node, document.body.children[0]);

    return {
      get width() {
        return node.clientWidth;
      },
      get height() {
        return node.clientHeight;
      },
      get orientation() {
        return node.clientHeight > node.clientWidth ? 'portrait' : 'landscape';
      },
      get fontSize() {
        return window.getComputedStyle(document.documentElement).getPropertyValue('font-size');
      }
    };
  }();

  var createHandler = function createHandler(feature, value) {
    if (feature === 'orientation') {
      return function () {
        return value === device.orientation;
      };
    }

    var _feature$split$revers = feature.split('-').reverse(),
        _feature$split$revers2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_feature$split$revers, 2),
        prop = _feature$split$revers2[0],
        limit = _feature$split$revers2[1];

    var operand = !limit ? '==' : limit === 'min' ? '<' : '>';

    var parseValue = function () {
      return ~value.indexOf('em') ? function () {
        return parseFloat(value) * device.fontSize;
      } : function () {
        return parseFloat(value);
      };
    }();

    var handlers = {
      'width': function width() {
        return eval(parseValue() + operand + device.width);
      },
      'height': function height() {
        return eval(parseValue() + operand + device.height);
      }
    };

    return handlers[prop];
  };

  var parseQuery = function parseQuery(queryString) {
    var _queryString$replace$ = queryString.replace(/[()\s]/g, '').split(':'),
        _queryString$replace$2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_queryString$replace$, 2),
        feature = _queryString$replace$2[0],
        value = _queryString$replace$2[1];

    return createHandler(feature, value);
  };

  window.addEventListener('resize', function () {
    if (!idle) return;
    idle = false;

    var width = device.width;
    var height = device.height;

    var timer = setInterval(function () {
      if (width !== device.width || height !== device.height) {
        width = device.width;
        height = device.height;
      } else {
        clearTimeout(timer);
        listeners.forEach(function (handler) {
          return handler();
        });
        idle = true;
      }
    }, 100);
  });

  return function (queryString) {
    var query = parseQuery(queryString);
    var matcher = {
      get matches() {
        return query();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matcher, {
      addListener: function addListener(cb) {
        var handler = function handler() {
          return cb(matcher);
        };
        listeners.push(handler);
      }
    });
  };
};

var matchMedia = window.matchMedia || matchMediaFallback();



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_resource__ = __webpack_require__("cb2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_device_queries__ = __webpack_require__("uJQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pace_progress__ = __webpack_require__("heTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pace_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pace_progress__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__plugins_resource__["a" /* default */], {
  resources: __WEBPACK_IMPORTED_MODULE_3__resources__,
  endpoint: '/static/api'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__plugins_device_queries__["a" /* default */], {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  laptop: 'min-width: 1025px',
  desktop: 'min-width: 1280px',
  monitor: 'min-width: 1448px'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_6_pace_progress___default.a.start();
    __WEBPACK_IMPORTED_MODULE_6_pace_progress___default.a.on('hide', function () {
      document.dispatchEvent(new Event('app.rendered'));
    });
  }
}).$mount('#app');

/***/ }),

/***/ "OJtK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"v--mask"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"blog__footer"},[_c('a',{staticClass:"signature",attrs:{"href":"/","target":"_parent","tite":"Iconic Typewriters"}},[_c('img',{attrs:{"src":__webpack_require__("7GPK"),"alt":"Iconic Typewriters"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PXyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('h1',{staticClass:"nav__title"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.content.title))])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/about"}},[_c('span',{staticClass:"blog__about"},[_vm._v("about")])]),_vm._v(" "),_c('transition-group',{staticClass:"nav__menu",attrs:{"tag":"menu","name":"nav__item"}},_vm._l((_vm.labels),function(label){return _c('li',{key:label,staticClass:"nav__item",on:{"click":_vm.navBack}},[_c('i',{staticClass:"nav__item--icon"}),_vm._v(" "),_c('span',{staticClass:"nav__item--label"},[_vm._v(_vm._s(label))])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc97134_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("yHa9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc97134_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var store = {};

  return {
    has: function has(uri) {
      return !!store[uri];
    },
    get: function get(uri) {
      return JSON.parse(store[uri]);
    },
    set: function set(uri, data) {
      store[uri] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    }
  };
})());

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__("c27y");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  linkActiveClass: "active",
  routes: [{
    path: "/",
    name: "feed",
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: "/by/:author",
    name: "author",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: "/read/:post",
    name: "post",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: "/about",
    name: "about",
    component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFooter__ = __webpack_require__("kYEd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blog",
  components: { BlogNav: __WEBPACK_IMPORTED_MODULE_0__BlogNav__["a" /* default */], BlogFooter: __WEBPACK_IMPORTED_MODULE_1__BlogFooter__["a" /* default */] },
  resource: "Blog",
  props: {
    post: String,
    author: String
  },

  data: function data() {
    return {
      navs: 0,
      title: "",
      labels: {
        post: "",
        author: ""
      }
    };
  },


  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels };
    },
    filters: function filters() {
      var filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    "$route.name": function $routeName(to, from) {
      if (to !== from) this.navs++;
    }
  },

  mounted: function mounted() {
    this.$getResource("blog").then(function (x) {
      // use pace hook to know when rendering is ready
    });
  }
});

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("SGec");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });


/***/ }),

/***/ "bksL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  feed: function feed() {
    return {
      path: '/feed.json',
      resolve: function resolve(response, mappers) {
        return mappers.pipe(response.results);
      }
    };
  }
});

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6b75f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("vV9U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6b75f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cX0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kebabify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prettyDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__ = __webpack_require__("M75F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__);



var scrollTo = function scrollTo(pos) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default()(document.documentElement, 'scrollTop', pos, duration, 'easeInOutSine', resolve);
    }, delay);
  });
};

var kebabify = function kebabify(words) {
  return words.toLowerCase().replace(' ', '-');
};

var prettyDate = function prettyDate(date) {
  return new Date(date).toString().split(' ').slice(0, 4).join(' ').replace(/( \d+)$/, ',$1');
};

/***/ }),

/***/ "cb2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache__ = __webpack_require__("WYec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__("mB6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);





// install $resource as a Vue plugin
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, _ref) {
    var _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === undefined ? '' : _ref$endpoint,
        _ref$resources = _ref.resources,
        resources = _ref$resources === undefined ? {} : _ref$resources;

    Vue.prototype.$getResource = function (method, options) {
      var _this = this;

      var name = this.$options.resource;
      if (!name || !resources[name] || !resources[name][method]) return;

      // get fetch path and response resolver/mapper

      var _resources$name$metho = resources[name][method](options),
          path = _resources$name$metho.path,
          resolve = _resources$name$metho.resolve;

      var uri = endpoint + path;

      // methods return promise to allow chaining
      var mappers = {
        // only return promise without modifying instance $data
        pipe: function pipe(dataSet) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // deep merge object with instance $data
        merge: function merge(dataSet) {
          __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(_this.$data, dataSet);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // set individual props on instance $data
        set: function set(dataSet) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataSet).forEach(function (prop) {
            _this.$set(_this.$data, prop, dataSet[prop]);
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        }

        // check to see if the resource has been cached already
      };if (__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].has(uri)) return resolve(__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].get(uri), mappers);

      // fetch, parse and cache resource then pass to resolver
      return fetch(uri).then(function (response) {
        return response.json();
      }).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].set(uri, response);
      }).then(function (response) {
        return resolve(response, mappers);
      });
    };
  }
});

/***/ }),

/***/ "eJ85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  blog: function blog() {
    return {
      path: '/blog.json',
      resolve: function resolve(response, mappers) {
        var blog = response.results[0];
        return mappers.merge({
          title: blog.title,
          labels: {
            post: blog.post_label,
            author: blog.author_label
          }
        });
      }
    };
  }
});

/***/ }),

/***/ "ggVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blog-nav",
  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    labels: function labels() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (filter) {
        return _this.content.labels[filter];
      });
    }
  },

  methods: {
    navBack: function navBack() {
      if (this.navs && !this.filters.author) this.$router.go(-1);else this.$router.push("/");
    }
  }
});

/***/ }),

/***/ "hi3H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kYEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__ = __webpack_require__("6Lyb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6f03bec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__ = __webpack_require__("OJtK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6f03bec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "num+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"post"}},[(_vm.allReady)?_c('article',{staticClass:"post"},[_c('header',{staticClass:"post__header"},[_c('h2',{staticClass:"post__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',{staticClass:"post__meta"},[_vm._v("\n        Made by\n        "),_c('router-link',{staticClass:"post__author",attrs:{"to":("/by/" + (_vm.kebabify(_vm.author)))}},[_vm._v(_vm._s(_vm.author))]),_vm._v(" "),_c('span',{staticClass:"post__sep"}),_vm._v(" "),(!_vm.sold)?_c('time',[_c('a',{staticClass:"buy",attrs:{"href":'https://ebay.com/itm/' + _vm.buy}},[_vm._v("Buy It Now")])]):_c('time',[_c('span',{staticClass:"s"},[_vm._v("SOLD OUT")])])],1),_vm._v(" "),_c('blockquote',{staticClass:"post__subtitle"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('section',{staticClass:"post__body rte",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.manual)?_c('section',[_c('div',{staticClass:"gviewer"},[_c('h2',[_vm._v("User's Manual")]),_vm._v(" "),_c('iframe',{staticClass:"viewer",attrs:{"src":'//docs.google.com/gview?url=' + _vm.manual + '&embedded=true',"width":"100%","height":"420","frameborder":"0"}}),_vm._v(" "),_c('small',{staticStyle:{"display":"block","color":"#999","font-family":"arial","font-size":"60%","text-align":"center","width":"100%","margin":"0 auto"}},[_vm._v("Can't load manual? Reload page")])])]):_vm._e(),_vm._v(" "),(_vm.buy !== 'null')?_c('section',[_c('p',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_c('a',{staticStyle:{"font-size":"smaller","float":"right"},attrs:{"href":'https://ebay.com/itm/' + _vm.buy}},[_vm._v("eBay Permalink")])])])]):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"post__footer"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rcwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(id) {
    return {
      path: '/post/' + id + '.json',
      resolve: function resolve(response, mappers) {
        var _response$results$ = response.results[0],
            title = _response$results$.title,
            content = _response$results$.content,
            meta = _response$results$.meta;

        content = '<p>' + content.split('\n\n').join('</p><p>') + '</p>';
        return mappers.merge(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ title: title, content: content }, meta));
      }
    };
  }
});

/***/ }),

/***/ "uJQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_media__ = __webpack_require__("MdQY");



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, queries) {
    var DeviceVM = new Vue({
      data: function data() {
        return {
          devices: {}
        };
      },


      methods: {
        addDevice: function addDevice(name, active) {
          var _this = this;

          this.$set(this.devices, name, active);

          return function (_ref) {
            var matches = _ref.matches;

            _this.devices[name] = matches;
          };
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queries).forEach(function (name) {
      var query = Object(__WEBPACK_IMPORTED_MODULE_1__match_media__["a" /* default */])('(' + queries[name] + ')');
      var update = DeviceVM.addDevice(name, query.matches);
      query.addListener(update);
    });

    Vue.prototype.$device = DeviceVM.devices;
  }
});

/***/ }),

/***/ "vV9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('blog-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"blog__feed"},[_c('li',[_c('div',{staticClass:"desc"},[_c('p',[_vm._v("Culturally, historically, or aesthetically significant typewriters, for sale or restoration.")]),_vm._v("(And don't you just love the sound a typewriter makes? It gives your writing its own soundtrack!)\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          --\n          "),_c('br'),_vm._v("Follow us on social:\n          "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.ebay.com/usr/iconictypewriters"}},[_vm._v("eBay")]),_vm._v(",\n          "),_c('a',{attrs:{"href":"https://www.instagram.com/iconictypewriters"}},[_vm._v("Instagram")]),_vm._v(",\n          "),_c('a',{attrs:{"href":"https://www.youtube.com/iconictypewriters"}},[_vm._v("YouTube")]),_vm._v(",\n          "),_c('a',{attrs:{"href":"https://www.facebook.com/iconictypewriters"}},[_vm._v("Facebook")]),_vm._v(", and\n          "),_c('a',{attrs:{"href":"https://www.twitter.com/Typewrite_rs"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          Or simply drop us a line:\n          "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:desk@typewrite.rs?subject=Hello"}},[_vm._v("desk@typewrite.rs")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'app' });

/***/ }),

/***/ "xdpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__ = __webpack_require__("2x06");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2120d6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__ = __webpack_require__("ILtd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2120d6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y7Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__ = __webpack_require__("ggVv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540c7f94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__ = __webpack_require__("PXyl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540c7f94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yHa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_c('blog-feed',{attrs:{"filters":_vm.filters}}),_vm._v(" "),_c('blog-post',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('blog-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.48488d692be1d4da9b6b.js